<router-outlet />
<app-snackbar />
<app-loader />
